module.exports = __webpack_public_path__ + "static/media/screen3-2x.737a778a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Phone/screen3-2x.jpg
// module id = 11
// module chunks = 0